import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'src/components/ui/button';
import { Icon } from 'src/components/ui/icon';
import { Typography } from 'src/components/ui/typography';
import { useLicenseDisclaimer } from 'src/hooks/useLicenseDisclaimer';
import { sidebarIcons } from 'src/layouts/SidebarV2/icons';
import { IconAction } from 'src/layouts/SidebarV2/primitives';
import { DISCLAIMER_ACTION_KIND } from 'src/types/enum';
import { NAVIGATIONS } from 'src/utils/constants';

const LicenseLimitReachedBadge = () => {
  const navigate = useNavigate();
  const disclaimer = useLicenseDisclaimer();
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible || !disclaimer) {
    return null;
  }

  const { message, action, isWarning } = disclaimer;

  return (
    <div
      className={`tw:relative tw:flex tw:w-full tw:flex-col tw:items-center tw:gap-m tw:rounded-2xl tw:border tw:border-solid tw:py-m ${
        isWarning
          ? 'tw:border-border-warning tw:bg-warning'
          : 'tw:border-error tw:bg-error'
      }`}
    >
      <IconAction
        icon={sidebarIcons.close}
        label="Dismiss"
        iconSize={16}
        colorClass="tw:text-icon-secondary"
        className="tw:absolute tw:right-s tw:top-s"
        onClick={() => setIsVisible(false)}
      />

      <div className="tw:flex tw:flex-col tw:items-center tw:gap-m tw:px-m">
        <div
          className={`tw:flex tw:items-center tw:justify-center tw:rounded-full tw:p-s ${
            isWarning ? 'tw:bg-warning-hover' : 'tw:bg-error-hover'
          }`}
        >
          <Icon
            icon={sidebarIcons.alertTriangle}
            size={16}
            colorClass={
              isWarning ? 'tw:text-icon-warning' : 'tw:text-icon-error'
            }
          />
        </div>

        <Typography
          variant="b3"
          align="center"
          colorClass="tw:text-text-primary"
        >
          {message}
        </Typography>
      </div>

      {action?.kind === DISCLAIMER_ACTION_KIND.CONTACT_SUPPORT ? (
        <Button hierarchy="link" size="small" asChild>
          <a href={`mailto:${action.email}`}>{action.label}</a>
        </Button>
      ) : action ? (
        <Button
          hierarchy="link"
          size="small"
          text={action.label}
          onClick={() => navigate(NAVIGATIONS.SETTINGS_PAY_AS_YOU_GO)}
          className="tw:cursor-pointer"
        />
      ) : null}
    </div>
  );
};

export { LicenseLimitReachedBadge };
